import config from '../config';

/* This example requires Tailwind CSS v2.0+ */
const faqs = [
  {
    id: 1,
    question: `How much ${process.env.NEXT_PUBLIC_TOKEN_ABBR} does a raffle ticket cost?`,
    answer: `Each raffle has its own 'Ticket cost'. Check the raffle you like for the corresponding ticket cost.`,
  },
  {
    id: 2,
    question: 'How many raffle tickets can I buy for each raffle?',
    answer: `You can buy as many tickets as your ${process.env.NEXT_PUBLIC_TOKEN_ABBR} balance will allow. The more tickets you buy, the higher your odds of winning.`,
  },
  {
    id: 3,
    question: `When buying a raffle ticket, what are the 2 parts of the transaction?`,
    answer: `The first part of the transaction sends ${process.env.NEXT_PUBLIC_TOKEN_ABBR} back to the creator wallet. The second part of the transaction opts you in to the prize.`,
  },
  {
    id: 4,
    question: `What happens when the raffle's timer runs out?`,
    answer: 'An address will be randomly selected from all of the entries and the prize will be automatically sent to the winning wallet.',
  },
];

export default function RaffleInfo() {
  return (
    <div className='mt-12 md:mt-36'>
      <div className='max-w-6xl mx-auto'>
        <div className='bg-gray-800 rounded-lg'>
          <div className='px-4 py-16 mx-auto max-w-7xl sm:py-24 sm:px-6 lg:px-8'>
            <h2 className='text-3xl font-extrabold text-gray-50'>How do {config.siteName} Raffles work?</h2>
            <div className='pt-10 mt-6 border-t border-gray-300 border-opacity-25'>
              <dl className='space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-12'>
                {faqs.map((faq) => (
                  <div key={faq.id}>
                    <dt className='text-lg font-medium leading-6 text-gray-50'>{faq.question}</dt>
                    <dd className='mt-2 text-base text-gray-400'>{faq.answer}</dd>
                  </div>
                ))}
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
